module.exports = __webpack_public_path__ + "static/img/wereldbord_nl.55b8f1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/wereldbord_nl.jpg
// module id = 7xuk
// module chunks = 0